import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';;
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { CardInputComponent } from './components/card-input/card-input.component';
import { CvcInputComponent } from './components/cvc-input/cvc-input.component';
import { MatIconModule } from '@angular/material/icon';
import { CardIconComponent } from './components/card-icon/card-icon.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    CardInputComponent,
    CvcInputComponent,
    CardIconComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatOptionModule,
    TranslateModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatStepperModule,
    RouterModule,
  ],
  exports: [
    CardInputComponent,
    CvcInputComponent,
    CardIconComponent,
  ],
})
export class SharedModule {}
